// ---------------------------------------------------------------------------
// View Transitions
// ---------------------------------------------------------------------------
// Progressive enhancement for multi-page published sites. Only enabled when
// the rendered site has navigation context, and only uses browser-native CSS.

import type { RenderInput } from "./types.js";

export const VIEW_TRANSITION_META =
  '<meta name="view-transition" content="same-origin">';

export function shouldEnableViewTransitions(input: RenderInput): boolean {
  const siteContext = input.siteContext;
  if (!siteContext) return false;

  const hasSiteNavigation = siteContext.mainNav.length > 0 || siteContext.footerNav.length > 0;
  const hasGlobalChrome = Boolean(siteContext.headerContent || siteContext.footerContent);

  return hasSiteNavigation || hasGlobalChrome;
}

export function buildViewTransitionStyleTag(input: RenderInput): string {
  const heroTransitionName = `ease-hero-${input.pageId}`;

  return `<style data-ease-view-transitions>
@view-transition { navigation: auto; }
::view-transition-old(ease-site-header),
::view-transition-new(ease-site-header),
::view-transition-old(ease-site-footer),
::view-transition-new(ease-site-footer){
  animation-duration:220ms;
  animation-timing-function:ease;
}
::view-transition-old(${heroTransitionName}),
::view-transition-new(${heroTransitionName}){
  animation-duration:260ms;
  animation-timing-function:ease;
}
@media (prefers-reduced-motion: reduce){
  ::view-transition-old(ease-site-header),
  ::view-transition-new(ease-site-header),
  ::view-transition-old(ease-site-footer),
  ::view-transition-new(ease-site-footer),
  ::view-transition-old(${heroTransitionName}),
  ::view-transition-new(${heroTransitionName}){
    animation-duration:0s;
  }
}
</style>`;
}

export function buildHeroTransitionName(pageId: string): string {
  return `ease-hero-${pageId}`;
}
